
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getLogin = {
  login(params) {
    return axios.post(
      `/api/admin/login`,
      qs.stringify(params)
    );
  },
};
export default getLogin;
